/* wan_op.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <polygon class="foreground-gl" points="0 1.13 2.12 1.13 2.12 0.09 4.7 3.31 2.12 6.53 2.12 5.39 0 5.39 0 1.13"/><polygon class="foreground-gl" points="0 12.12 0 7.86 3.81 7.86 3.81 6.82 6.39 10.04 3.81 13.27 3.81 12.12 0 12.12"/><polygon class="foreground-gl" points="0 18.85 0 14.6 2.12 14.6 2.12 13.56 4.7 16.78 2.12 20 2.12 18.85 0 18.85"/><polygon class="foreground-gl" points="4.83 19.88 7.88 10.07 4.74 0.14 7.12 0.14 12.26 10.34 7.21 19.88 4.83 19.88"/><polygon class="foreground-gl" points="10.63 19.95 10.63 15.77 8.06 15.77 8.85 10.04 8.21 4.54 10.63 4.54 10.63 0 19.87 9.98 10.63 19.95"/>
        </svg>
    `
};
